import { CSS_PROPERTY, getCssBasedOnRtl, media } from '../../styles';

import styled from 'styled-components';

type ContainerProps = {
  withoutMargin?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  margin-bottom: ${({ theme, withoutMargin }) => (withoutMargin ? '0' : theme.spacing.base.sm)};
  padding-top: ${({ theme }) => theme.spacing.base.xs};
  ${media.mobilePortrait} {
    flex-wrap: wrap;
    padding-top: 0;
  }
  ${media.mobileLandscape} {
    padding-top: ${({ theme }) => theme.spacing.base.sm};
  }
`;

export const AnchorContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const AnchorTags = styled.a`
  align-items: center;
  color: ${({ theme }) => theme.ui.links.fontColor};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding-top: ${({ theme }) => theme.spacing.base.xxs};
  font-size: ${({ theme }) => theme.typography.size.small};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.sm)};
  outline: none;
  text-decoration: none;
  word-break: break-word;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }

  ${media.mobilePortrait} {
    ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.mobile.lg)};
  }
`;

export const Icon = styled.i`
  color: ${({ theme }) => theme.ui.links.iconColor};
  height: 15px;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.xxs)};
  padding-top: ${({ theme }) => theme.spacing.base.xxs};
  width: 14px;
`;

export const ChildrenContainer = styled.div`
  display: flex;
`;
